// 데모 리포트 모드 — 시연 계정 한정 스위치.
//
// 켜지면 리포트 홈(배달 제외)·이벤트·캠페인 리포트의 API 호출을 정적 번들
// (public/demo/**, 생성기: sales-server/script/demo_report) 로 대체한다.
// 스위치는 sessionStorage — 탭을 닫으면 꺼진다. 다른 계정에서는 아무 효과가 없다.
export const DEMO_STORE_ID = "st_MmUzOGQ2NWFlNmNhNmRiM2Vk";

const STORAGE_KEY = "growing.demoReport.active";

// 번들의 데모 월 — 생성기 config.DEMO_START/END 와 같이 움직인다 (manifest.period 가 진실,
// 여기 값은 manifest 도착 전 초기 상태용).
export const DEMO_PERIOD = { start: "2026-08-01", end: "2026-08-31" };
// 멤버십 리포트 기본 주차 보기 — 데모 월을 덮는 ISO 주 5주 (생성기 config.DEMO_WEEK_START/END 와 동일)
export const DEMO_WEEK_PERIOD = { start: "2026-07-27", end: "2026-08-30" };

export const DEMO_BASE = `${process.env.PUBLIC_URL || ""}/demo`;

export const isDemoEligible = (storeId) => storeId === DEMO_STORE_ID;

/** 데모 모드 활성 — storeId 를 주면 시연 계정이 아닐 때 항상 false */
export const isDemoActive = (storeId) => {
  if (storeId && !isDemoEligible(storeId)) return false;
  try {
    return window.sessionStorage.getItem(STORAGE_KEY) === "1";
  } catch (e) {
    return false;
  }
};

export const setDemoActive = (on) => {
  try {
    if (on) window.sessionStorage.setItem(STORAGE_KEY, "1");
    else window.sessionStorage.removeItem(STORAGE_KEY);
  } catch (e) {
    // sessionStorage 불가 환경 — 무시
  }
};

/** 데모 월 [start, end] — 로컬 자정/23:59:59 */
export const demoPeriodDates = (period = DEMO_PERIOD) => {
  const start = new Date(`${period.start}T00:00:00`);
  const end = new Date(`${period.end}T23:59:59.999`);
  return [start, end];
};
